var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7082 7.5C17.4229 7.56133 18.8789 8.84744 18.8321 10.5703C18.8212 10.9711 18.6659 11.4665 18.3553 12.4574C17.608 14.842 16.352 16.912 13.5383 17.4087C13.0211 17.5 12.4391 17.5 11.2751 17.5H9.72459C8.56059 17.5 7.97859 17.5 7.46137 17.4087C4.64766 16.912 3.39165 14.842 2.6443 12.4574C2.33377 11.4665 2.17849 10.9711 2.1676 10.5703C2.12077 8.84744 3.57675 7.56133 5.29151 7.5",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 11.6667V2.5M10.4998 11.6667C9.91634 11.6667 8.82611 10.0047 8.4165 9.58333M10.4998 11.6667C11.0833 11.6667 12.1736 10.0047 12.5832 9.58333",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.ffb36dc728bda59954bf07dffdf1a695.svg";
export { ForwardRef as ReactComponent };